import { keycloakObj} from "@/utils";
import { $accounts, $marketing } from "./apis/http/http";
import { $identity } from "@/services/apis/";

/**
 * Fetches user profile details of logged in user
 */
export const getUserProfile = async () => {
  const { baseURL } = keycloakObj()
  return $identity.get("account", { baseURL, withCredentials: true });
};


export const userAccounts = (params = {}) => {
  const { module, ...queryParams } = { ...params, sort_by: 'name', sort_order: 'asc' };

  if (module) {
    queryParams[module] = true;
  }

  return $accounts.get("accounts.json", { params: queryParams });
};

export const updateHubSpotInfo = (data) => {
  return $accounts.post("hubspot_contacts/update",data);
};

/**
 * Updates a user profile record in Keycloak
 * @param {Object} payload - User profile data to update
 * @returns {Promise<Object>} API response
 */
export const updateUserProfile = (payload) => {
  const { baseURL } = keycloakObj()
  return $identity.post("account", payload, { baseURL });
};

export const userLists = (accoutId,params) =>{
  return $marketing.get(`${accoutId}/lists.json`, { params });
}

export const genrateConnectorToken = (accountId) =>{
  return $marketing.post(`/${accountId}/connector/auth_tokens.json`);
}